import React from "react";
import styled from "styled-components";
import { LegalFooter, Low6Footer } from "../";

const StyledWrapper = styled.div`
  margin-bottom: 7rem;
`;

const Wrapper = () => {
  return (
    <StyledWrapper>
      <LegalFooter />
      <Low6Footer />
    </StyledWrapper>
  );
};

export default Wrapper;
